import * as React from 'react';
import Button from '../../../Button/Button';
import Dialog from '@material-ui/core/Dialog';
import MenuList from '@material-ui/core/MenuList';
import MenuItem from '@material-ui/core/MenuItem';
import './Cancel.css';
import { LibraryCard, CardPropertyType, CardProperties, CardType } from '../../../../types/LibraryCard';
import saveCardProperties from '../../../../requests/saveCardProperties';

interface Props {
	card: LibraryCard;
	saveCardProperties: (cardId: number, properties: CardProperties) => Promise<boolean>;
	deleteCard: (cardId: number) => Promise<boolean>;
}

const Cancel: React.FC<Props> = props => {
	const [open, setOpen] = React.useState(false);
	const [isLoading, setLoading] = React.useState(false);

	const onClickHandler = (type: 'clear_date' | 'move_out' | 'delete') => {
		setLoading(true);

		if (type === 'delete') {
			props.deleteCard(props.card.eId);
		}
		else {
			const params: CardProperties = {};

			if (type === 'clear_date') {
				params[CardPropertyType.DateBegin] = '';
				params[CardPropertyType.DateFinish] = '';
			}
			else {
				params[CardPropertyType.Type] = CardType.AlreadyRead;
				params[CardPropertyType.DateBegin] = "";
				params[CardPropertyType.DateFinish] = "";
			}

			props.saveCardProperties(props.card.eId, params);
		}
		setOpen(false);
		setLoading(false);
	};

	return <>
		<Button isLoading={isLoading} onClick={() => setOpen(true)}>
			Отменить планы
		</Button>

		<Dialog open={open} onClose={() => setOpen(false)}>
			<div>
				<div className="cancel-header">
					Что вы хотите сделать?
				</div>

				<MenuList>
					{props.card.properties[CardPropertyType.DateBegin] && <MenuItem onClick={() => onClickHandler(
						'clear_date'
					)}>
						Удалить даты и оставить в запланированном
					</MenuItem>}
					{props.card.history.length > 0 && <MenuItem onClick={() => onClickHandler(
						'move_out'
					)}>
						Перенести обратно в Прочитано
					</MenuItem>}
					<MenuItem onClick={() => onClickHandler('delete')} className="cancel-delete">Удалить книгу из библиотеки</MenuItem>
					<MenuItem onClick={() => setOpen(false)}>Ничего</MenuItem>
				</MenuList>
			</div>
		</Dialog>
	</>;
};

export default Cancel;
